var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expert-layout"},[_c('router-view',{staticClass:"content"}),_c('expert-tab-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }